import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import PartnersRequest from '../../../RunPay/Admin/IServices/Models/Partners/PartnersRequest';
import SavePartnerRequest from '../../../RunPay/Admin/IServices/Models/Partners/SavePartnerRequest';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';
import PaginationResponse from '../../../Common/ResponseModels/PaginationResponse';
import PartnersItemResponse from '../../../RunPay/Admin/IServices/Models/Partners/PartnersItemResponse';
import BaseResponse from '../../../Common/ResponseModels/BaseResponse';

export default class PartnersService {
	webApiService: WebApiService;
	GetListEvent = new Events<WsResponseModel<PaginationResponse<PartnersItemResponse>>>();
	SaveEvent = new Events<WsResponseModel<BaseResponse>>();
	DeleteEvent = new Events<WsResponseModel<BaseResponse>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('PartnersService', 'GetList', (res: WsResponseModel<PaginationResponse<PartnersItemResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('PartnersService', 'Save', (res: WsResponseModel<BaseResponse>) => {
			self.SaveEvent.trigger(res);
		});
		webApiService.on('PartnersService', 'Delete', (res: WsResponseModel<BaseResponse>) => {
			self.DeleteEvent.trigger(res);
		});
	}
	GetList(request: PartnersRequest = null) { 	
        this.webApiService.send('PartnersService', 'GetList' , request);
    }
	Save(request: SavePartnerRequest = null) { 	
        this.webApiService.send('PartnersService', 'Save' , request);
    }
	Delete(id: number = 0) { 	
        this.webApiService.send('PartnersService', 'Delete' , id);
    }
	 // async methods
	async getListAsync(request: PartnersRequest = null): Promise<PaginationResponse<PartnersItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async saveAsync(request: SavePartnerRequest = null): Promise<BaseResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.Save.bind(this), this.SaveEvent)(request);
	}
	async deleteAsync(id: number = 0): Promise<BaseResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/PartnersService.ts